import { FEATURES } from "@src/constants";

export type IAppRoute = {
  name: string;
  title: string;
  path: string;
  adminOnly?: boolean;
};

export const curatorRoutes: IAppRoute[] = [
  {
    name: "playlist",
    title: "Playlist",
    path: "/",
  },
  {
    name: "library",
    title: "Library",
    path: "/library",
  },
  ...(FEATURES.MESSAGING_ENABLED
    ? [
        {
          name: "messages",
          title: "Messages",
          path: "/messages",
        },
      ]
    : []),
  {
    name: "schedule",
    title: "Schedule",
    path: "/schedule-calendar",
  },
  {
    name: "guest-curator",
    title: "Guest Curator",
    path: "/guest-curator",
  },

  ...(FEATURES.ARTICLES_ENABLED
    ? [
        {
          name: "articles",
          title: "Articles",
          path: "/articles",
        },
      ]
    : []),
  // Shown only to curators with `vinylListEnabled` (see useAuthorizedRoutes).
  {
    name: "vinyl-list",
    title: "My Vinyl List",
    path: "/vinyl-list",
  },
  ...(FEATURES.INVOICES_ENABLED
    ? [
        {
          name: "invoices",
          title: "Invoices",
          path: "/invoices",
        },
      ]
    : []),
  ...(FEATURES.SOCIAL_MEDIA_PROMO_CURATOR_ENABLED
    ? [
        {
          name: "social-media-promo",
          title: "Social Media Promo",
          path: "/social-media-promo",
        },
      ]
    : []),
];

export const adminRoutes: IAppRoute[] = [
  {
    name: "playlist",
    title: "Playlist",
    path: "/",
  },
  {
    name: "library",
    title: "Library",
    path: "/library",
  },
  {
    name: "schedule",
    title: "Schedule",
    path: "/schedule-calendar",
  },
  {
    name: "moods",
    title: "Moods",
    path: "/mood-factory",
  },
  ...(FEATURES.SOCIAL_MEDIA_PROMO_ADMIN_ENABLED
    ? [
        {
          name: "social-media-promo",
          title: "Social Media Promo",
          path: "/social-media-promo",
        },
      ]
    : []),
  ...(FEATURES.ARTICLES_ENABLED
    ? [
        {
          name: "articles",
          title: "Articles",
          path: "/articles",
        },
      ]
    : []),
  {
    name: "curator-management",
    title: "Curator Management",
    path: "/curator-management",
  },
  ...(FEATURES.CLIENTS_EXPORT_ENABLED
    ? [
        {
          name: "clients-export",
          title: "Clients Export",
          path: "/clients-export",
          adminOnly: true,
        },
      ]
    : []),
  ...(FEATURES.SCHEDULE_BOARD_ENABLED
    ? [
        {
          name: "schedule-board",
          title: "Schedule Board",
          path: "/schedule-board",
          adminOnly: true,
        },
      ]
    : []),
  {
    name: "vinyl-list",
    title: "Vinyl List",
    path: "/vinyl-list",
  },
  ...(FEATURES.INVOICES_ENABLED
    ? [
        {
          name: "invoices",
          title: "Invoices",
          path: "/invoices",
        },
      ]
    : []),
  ...(FEATURES.STATUS_CHECK_ENABLED
    ? [
        {
          name: "status-check",
          title: "Status Check",
          path: "/status-check",
          adminOnly: true,
        },
      ]
    : []),
  // No `adminOnly`: managers keep the tab. One whose configuration leaves out
  // `admin-messages` is shown the "no permission" page when opening it.
  ...(FEATURES.ADMIN_CURATOR_MESSAGES_ENABLED
    ? [
        {
          name: "admin-messages",
          title: "All Messages",
          path: "/admin-messages",
        },
      ]
    : []),
];
